import { CardBlock } from '@coast/schemas';
import { useContext } from 'react';
import { View } from '@shared/components/View';
import { API } from '@shared/types/api';
import { ChannelPermissionsContext } from '@shared/util/permissions/ChannelPermissionsContext';
import { PrintModeContext } from '@shared/util/print/PrintContext';
import { CardChannelContext } from './contexts/channel';
import { useCardFormContext } from './contexts/form';
import { CardLayoutContext, CardRenderContext } from './contexts/render';
import { MBRedactedCardLines } from './redactedCardLines';
import { renderBlock, renderNonEmptyBlocks } from './render';
import { getBlockWidths } from './utils';

interface Props {
  card: API.CardFragment;
  blocks: CardBlock[];
  sticky?: boolean;
  onFieldPress?(): void;
}

export function MBCardBlocks({ blocks, card, sticky, onFieldPress }: Props) {
  const { values } = useCardFormContext();
  const printing = useContext(PrintModeContext);
  const renderContext = useContext(CardRenderContext);
  const layoutMode = useContext(CardLayoutContext);
  const channel = useContext(CardChannelContext);
  const channelPermissions = useContext(ChannelPermissionsContext);
  const workflowTemplateId = card.workflowTemplateId ?? channel?.workflowTemplateId ?? undefined;

  if (layoutMode === 'row') {
    const widths = getBlockWidths(blocks);
    return (
      <View row centerVertically flex padding={1}>
        {blocks.map((block, i) => (
          <View key={i} style={{ width: widths[i] }}>
            {renderBlock(block, card, values, onFieldPress, i + 1, workflowTemplateId)}
          </View>
        ))}
      </View>
    );
  }
  return (
    <>
      {!sticky && <View paddingTop={renderContext === 'calendar' ? 0.5 : 1} />}
      {renderNonEmptyBlocks(
        blocks,
        card,
        values,
        channelPermissions.canReadThread.enabled,
        channelPermissions.canCreateThread.enabled,
        channelPermissions.canUpdateCard.enabled,
        printing,
        onFieldPress,
        workflowTemplateId,
      )}
      {card.planLimitImposed && <MBRedactedCardLines />}
      {!sticky && <View paddingBottom={renderContext === 'calendar' ? 0.5 : 1} />}
    </>
  );
}
